import Dialog from '@/components/Dialog';
import { classes } from './utils';

export type AttachmentPreviewDialogProps = {
  name: string;
  src: string;
  onClose: () => void;
};

export default function AttachmentPreviewDialog({
  name,
  src,
  onClose,
}: AttachmentPreviewDialogProps) {
  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <div className={classes.imgWrapper}>
        <img className={classes.img} alt={name} src={src} />
      </div>
    </Dialog>
  );
}
